export class LinkedAccountItem {
    account: boolean;
    id: string;
    number: string;
    type: boolean;
    typeCode: string;
    inputValue: string; // for UI
}